import { Position } from './position.model';

export class ClientPosition {

  public clientX: number;
  public clientY: number;
  public position?: Position;

}
